export const getAllVehicles = (state) => state.vehicleSection.vehicles;
export const getCurrentVehicle = (state) => state.vehicleSection.currentVehicle;
export const isLoading = (state) => state.vehicleSection.loading;
export const getTotalVehicleCount = (state) => state.vehicleSection.total;
export const getNextVehiclesLink = (state) => state.vehicleSection.nextLink;
export const getIsVehiclesFetching = (state) => state.vehicleSection.loading;
export const getIsVehiclesFetchingNext = (state) => state.vehicleSection.loadingNext;
